import request from '@/http/http'
const PREFIX = 'api/deer/news';
export function getInformationList(query) {
    return request({
        url: PREFIX,
        params: query
    })
}
export function getInformationMaterials(id) {
  return request({
      url: PREFIX+"/materials?informationId="+id,
  })
}
export function creatInformation(data) {
    return request({
        url: PREFIX,
        method: 'post',
        data: data,

    })
}
export function updateStatus(id,status){
  return request({
    url: `${PREFIX}/${id}/update-status-type?statusType=${status}`,
    method: 'put',
  })
}
export function getInformation(id){
  return request({
    url: `${PREFIX}/${id}`,
  })
}
export function updateInformation(id,data){
    return request({
      url: `${PREFIX}/${id}`,
      method: 'put',
      data
    })
  }
export function deleteInformation(id) {
    return request({
        url: `${PREFIX}/${id}`,
        method: 'delete',
      })
}
export function deleteInformationList(ids) {
  return request({
      url: `${PREFIX}`,
      method: 'delete',
      data:ids
    })
}

export function uploadInformationfile(formData) {
  return request({
      url: `${PREFIX}/upload-file`,
      method: 'post',
      data:formData,
      headers: {
        "Content-Type": "multipart/form-data"
      }

    })
}